export const goalDriven = (
  <div className="overflow-x-auto mt-6">
    <table className="min-w-full table-auto border border-gray-300 text-sm">
      <thead>
        <tr className="bg-purple-700 text-white text-left">
          <th className="px-4 py-2 border">Inherent Strengths</th>
          <th className="px-4 py-2 border">Communication Preferences</th>
          <th className="px-4 py-2 border">Leadership Preferences</th>
          <th className="px-4 py-2 border">
            Stress Profile – situation that you may find stressful
          </th>
        </tr>
      </thead>
      <tbody className="bg-white text-gray-800">
        <tr>
          <td className="px-4 py-2 border">
            <ul className="list-disc ml-4 space-y-1">
              <li>Analyzing & Diagnosing</li>
              <li>Finance & Numbers</li>
              <li>Logical Processing</li>
              <li>Problem Solving</li>
            </ul>
          </td>
          <td className="px-4 py-2 border">
            <ul className="list-disc ml-4 space-y-1">
              <li>Facts, no Fluff</li>
              <li>Technical Accuracy</li>
              <li>Brief, Clear, Precise</li>
              <li>Straight Forward</li>
            </ul>
          </td>
          <td className="px-4 py-2 border">
            <ul className="list-disc ml-4 space-y-1">
              <li>Authoritative</li>
              <li>Analytical</li>
              <li>Directive</li>
              <li>Factual</li>
            </ul>
          </td>
          <td className="px-4 py-2 border">
            <ul className="list-disc ml-4 space-y-1">
              <li>Lack of facts to substantiate ideas</li>
              <li>Unclear goals and moving targets</li>
              <li>Inefficiencies and time wasting</li>
              <li>Vague, ambiguous answers</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export const taskDriven = (
  <div className="overflow-x-auto mt-6">
    <table className="min-w-full table-auto border border-gray-300 text-sm">
      <thead>
        <tr className="bg-purple-700 text-white">
          <th className="px-4 py-2 border">Inherent Strengths</th>
          <th className="px-4 py-2 border">Communication Preferences</th>
          <th className="px-4 py-2 border">Leadership Preferences</th>
          <th className="px-4 py-2 border">
            Stress Profile – situation that you may find stressful
          </th>
        </tr>
      </thead>
      <tbody className="bg-white text-gray-800">
        <tr>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Planning</li>
              <li>Establishing Order</li>
              <li>Attending to Detail</li>
              <li>Control Preference</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Details</li>
              <li>Action Plans</li>
              <li>Thoroughness</li>
              <li>Rules & Procedures</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Traditional</li>
              <li>Organized</li>
              <li>Accountable</li>
              <li>Conservative</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Too fast a pace of change</li>
              <li>Changes in plans mid-route</li>
              <li>Unexpected delays/poor planning</li>
              <li>Lack of structure, unpredictable events</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export const visionDriven = (
  <div className="overflow-x-auto mt-6">
    <table className="min-w-full table-auto border border-gray-300 text-sm">
      <thead>
        <tr className="bg-purple-700 text-white">
          <th className="px-4 py-2 border">Inherent Strengths</th>
          <th className="px-4 py-2 border">Communication Preferences</th>
          <th className="px-4 py-2 border">Leadership Preferences</th>
          <th className="px-4 py-2 border">
            Stress Profile – situation that you may find stressful
          </th>
        </tr>
      </thead>
      <tbody className="bg-white text-gray-800">
        <tr>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Bringing about Change</li>
              <li>Creativity & Innovation</li>
              <li>Future Orientation</li>
              <li>Risk-taking</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Big Picture Overview</li>
              <li>Imaginative</li>
              <li>Metaphors</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Entrepreneurial</li>
              <li>Adventurous</li>
              <li>Visionary</li>
              <li>Holistic</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Absence of ideas/creative problem solving</li>
              <li>Inflexibility in a changing world</li>
              <li>Lack of freedom to innovate</li>
              <li>Feeling ‘caged in’</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

export const peopleVision = (
  <div className="overflow-x-auto mt-6">
    <table className="min-w-full table-auto border border-gray-300 text-sm">
      <thead>
        <tr className="bg-purple-700 text-white">
          <th className="px-4 py-2 border">Inherent Strengths</th>
          <th className="px-4 py-2 border">Communication Preferences</th>
          <th className="px-4 py-2 border">Leadership Preferences</th>
          <th className="px-4 py-2 border">
            Stress Profile – situation that you may find stressful
          </th>
        </tr>
      </thead>
      <tbody className="bg-white text-gray-800">
        <tr>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Picture Overview</li>
              <li>Imaginative</li>
              <li>Metaphors</li>
              <li>Exploration</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Open Discussion</li>
              <li>Stories/Examples</li>
              <li>Feelings & Values</li>
              <li>Empathy & Consideration</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Supportive</li>
              <li>Personable</li>
              <li>Communicative</li>
              <li>Team-Oriented</li>
            </ul>
          </td>
          <td className="px-4 py-2 border align-top">
            <ul className="list-disc ml-4 space-y-1">
              <li>Lack of personal interaction/support</li>
              <li>Lack of participation in change decisions</li>
              <li>Impersonal handling and decision making</li>
              <li>No communication about what is happening</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);
